import {MaybePromise} from '@coolcolduk/typescript-util';

/**
 * run function and catch error
 * @param fn
 * @returns error message or undefined when successful
 */
export default async function messageWhenThrown(fn: () => MaybePromise<any>): Promise<string | undefined> {
  try {
    await fn();
    return undefined;
  } catch (e: any) {
    return e.message;
  }
}
